import { render } from "./HistoireDash.vue?vue&type=template&id=40e1a988"
import script from "./HistoireDash.vue?vue&type=script&lang=js"
export * from "./HistoireDash.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__